// ./src/config/transition.ts

// Usuários
// eslint-disable-next-line
const rebox_user_status: any = {
  active: 'Ativo',
  inactive: 'Inativo',
  suspended: 'Suspenso',
  incomplete: 'Incompleto',
  deleted: 'Deletado',
  lead: 'Lead',
  undefined: '',
};
// eslint-disable-next-line
const rebox_user_role: any = {
  admin: 'Admin',
  supervisor: 'Supervisor',
  assistant: 'Assistente',
  attendant: 'Atendente',
  client: 'Cliente',
  motorist: 'Motorista',
  partner: 'Afiliado',
  provider: 'Prestador',
};
// eslint-disable-next-line
const rebox_user_access_level: any = {
  low: 'Promotor' /* Promotor */,
  normal: 'Afiliado' /* Afiliado */,
  high: 'Parceiro' /* Parceiro */,
};
const rebox_user_person_type: any = {
  physical_person: 'Pessoa física',
  legal_person: 'Pessoa jurídica',
};

// Veículos
// eslint-disable-next-line
const rebox_vehicles_classifications: any = {
  passenger_car: 'Carros leves',
  moto: 'Motos',
  pickup_suv: 'Picapes ou suv',
  quadricycle: 'Quadricíclo',
  tricycle: 'Tricíclo',
  pickup_van_utilities: 'Vans ou utilitários',
  undefined: '',
};
// eslint-disable-next-line
const rebox_vehicles_status: any = {
  active: 'Ativo',
  inactive: 'Inativo',
  undefined: '',
};
// eslint-disable-next-line
const rebox_vehicles_colors: any = {
  undefined: 'Outra', // Outras
  yellow: 'Amarela', // Amarela
  blue: 'Azul', // Azul
  beige: 'Bege', // Bege
  white: 'Branca', // Branca
  gray: 'Cinza', // Cinza
  brown: 'Marrom', // Marrom
  silver: 'Prata', // Prata
  black: 'Preta', // Preta
  green: 'Verde', // Verde
  red: 'Vermelha', // Vermelho
};

// Contratos
// eslint-disable-next-line
const rebox_contracts_status: any = {
  pending: 'Pendente',
  canceled: 'Cancelado',
  released: 'Realizado',
  deleted: 'Deletado',
};
// eslint-disable-next-line
const rebox_contracts_current_payments_status: any = {
  in_day: 'Em dia',
  waiting: 'Aguardando',
  overdue: 'Em atraso',
  stop: 'Cancelado',
  undefined: '',
};
// eslint-disable-next-line
const rebox_contracts_type_grace_period: any = {
  finished: 'Cumprida',
  onHold: 'Em espera',
};
// eslint-disable-next-line
const rebox_contracts_form_of_payment: any = {
  boleto: 'Boleto',
  credit_card: 'Cartão de crédito',
  debit_card: 'Cartão de débito',
  undefined: '',
};

// Vendas
// eslint-disable-next-line
const rebox_sales_new_field_type: any = {
  user_email: 'E-mail',
  user_cpf: 'CPF',
  user_cnpj: 'CNPJ',
};

// Chamados
// eslint-disable-next-line
const rebox_called_vehicle_situation: any = {
  stopped_working: 'Parou de funcionar',
  overturn: 'Capotado',
  wheel_problem: 'Problema na roda',
  locked_gear: 'Câmbio travado',
  attic_wheel: 'Roda furtada',
  others: 'Não especificado',
  undefined: '',
};
const rebox_called_location_type: any = {
  public_highway: 'Via pública',
  basement_garage: 'Garagem subsolo',
  street_level_garage: 'Garagem nível da rua',
  bluff_off_track: 'Ribanceira / Fora da via',
  undefined: '',
};
const rebox_called_status: any = {
  open: 'Em aberto', // Quando o chamado foi feito
  in_progress: 'Prest. à caminho', // Quando a rebox já encaminhou para o pretador
  in_attendance: 'Em atendimento', // Quando o prestador enviou um colaborador para atender o chamado
  done: 'Concluído', // Quando o chamado foi concluído pela equipe
  deleted: 'Deletado', // Quando o chamado foi deletado do sistema
  canceled: 'Cancelado', // Quando o solicitante/cliente decide cancelar o chamado
  undefined: '',
};
const rebox_called_counter_by_status: any = {
  open: 'Aguardando',
  in_progress: 'A caminho',
  in_attendance: 'Prestando serviço',
  done: 'Encerrada',
  deleted: 'Encerrada',
  canceled: 'Encerrada',
  undefined: 'Encerrada',
};
const rebox_called_field_type: any = {
  user_name: 'Nome/Razão Social',
  user_email: 'E-mail',
  user_cpf: 'CPF',
  user_cnpj: 'CNPJ',
  user_cellphone: 'Telefone',
  user_address: 'Endereço',
};

// Resgates
const rebox_rescues_status: any = {
  canceled: 'Cancelado',
  paid: 'Pago',
  pending: 'Pendente',
  reject: 'Rejeitado',
  undefined: '',
};

// Pagamentos
const rebox_payments_status: any = {
  created: 'Gerada' /* Geração de nova cobrança. */,
  updated:
    'Atualizada' /* Alteração no vencimento ou valor de cobrança existente. */,
  confirmed:
    'Confirmada' /* Cobrança confirmada (pagamento efetuado, porém o saldo ainda não foi disponibilizado). */,
  received_in_cash: 'Recebida',
  received: 'Recebida' /* Cobrança recebida. */,
  pending: 'Pendente' /* Cobrança pendente */,
  overdue: 'Atrasada' /* Cobrança vencida. */,
  canceled: 'Cancelada' /* Cobrança cancelada. */,
  deleted: 'Deletada' /* Cobrança removida. */,
  restored: 'Restaurada' /* Cobrança restaurada. */,
  refunded: 'Estornada' /* Cobrança estornada. */,
  undefined: '',
};
const rebox_payments_form_of_payment: any = {
  boleto: 'Boleto',
  credit_card: 'Cartão de crédito',
  debit_card: 'Cartão de débito',
  transfer: 'Transferência',
  deposit: 'Deposito',
  subscription_plan: 'Coberto pelo plano',
  cash: 'Dinheiro',
  pix: 'Pix',
  undefined: '',
};

// indicações

const rebox_indications_status: any = {
  created: 'Em espera',
  canceled: 'Cancelada',
  effective: 'Efetivada',
  undefined: '',
};

const rebox_indications_payments_status: any = {
  pending: 'Pendente',
  confirmed: 'Confirmado',
};

// Carros
const rebox_cars_status: any = {
  active: 'ativo',
  inactive: 'inativo',
};

export default {
  rebox_user_status,
  rebox_vehicles_classifications,
  rebox_vehicles_status,
  rebox_vehicles_colors,
  rebox_user_role,
  rebox_user_access_level,
  rebox_user_person_type,
  rebox_contracts_status,
  rebox_contracts_current_payments_status,
  rebox_contracts_type_grace_period,
  rebox_contracts_form_of_payment,
  rebox_sales_new_field_type,
  rebox_called_vehicle_situation,
  rebox_called_location_type,
  rebox_called_status,
  rebox_called_counter_by_status,
  rebox_called_field_type,
  rebox_rescues_status,
  rebox_payments_status,
  rebox_payments_form_of_payment,
  rebox_indications_status,
  rebox_cars_status,
  rebox_indications_payments_status,
};
